import { createSelector } from 'reselect';
import { performanceChartSelector } from './simple-selectors';

export const performanceChartNavSelector = createSelector(
    performanceChartSelector,
    performanceChart => performanceChart.nav
);